import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { registerVendor } from "../../services/api";
import "../../vendor-panel.css";
import logo from "../../assets/vangle.jpeg";

const VendorRegisterPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "", email: "", password: "", businessName: "", contactNumber: "",
    gstNo: "", panNo: "", aadhaarNo: "",
    address: { street: "", city: "", state: "", pincode: "" },
    bankDetails: { accountHolderName: "", accountNumber: "", ifscCode: "", bankName: "" },
    termsAccepted: false,
  });
  const [files, setFiles] = useState({ panCard: null, aadhaarCard: null, agreement: null });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleNested = (e, section) => setForm({ ...form, [section]: { ...form[section], [e.target.name]: e.target.value } });
  const handleFileChange = (e) => setFiles({ ...files, [e.target.name]: e.target.files[0] });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!form.termsAccepted) return setError("Please accept Terms & Conditions");
    setLoading(true);
    try {
      const formData = new FormData();
      Object.keys(form).forEach(key => formData.append(key, typeof form[key] === "object" ? JSON.stringify(form[key]) : form[key]));
      formData.append("panCard", files.panCard);
      formData.append("aadhaarCard", files.aadhaarCard);
      formData.append("agreement", files.agreement);
      await registerVendor(formData);
      alert("Registration successful! Verification in progress.");
      navigate("/vendor/login");
    } catch (err) {
      setError(err.response?.data?.message || "Registration failed");
    } finally { setLoading(false); }
  };

  const Input = ({ label, name, type = "text", section, required }) => (
    <div className="vp-form-group">
      <label>{label}{required && " *"}</label>
      <input className="vp-input" type={type} name={name} placeholder={label}
        value={section ? form[section][name] : form[name]}
        onChange={section ? (e) => handleNested(e, section) : handleChange}
        required={required} />
    </div>
  );

  const FileBox = ({ label, name }) => (
    <div className="vp-form-group">
      <label>{label}</label>
      <div className="vp-file-upload">
        <input type="file" name={name} onChange={handleFileChange} required />
        <div className="vp-file-upload-label">
          {files[name] ? <strong>{files[name].name}</strong> : <><span>Click to upload</span><strong>{label}</strong></>}
        </div>
      </div>
    </div>
  );

  return (
    <div className="vp-auth-wrapper">
      <div className="vp-auth-container-lg">
        <div className="vp-auth-brand" style={{ marginBottom: 20 }}>
          <img src={logo} alt="V Angel Coin" />
          <h1>V Angel Coin</h1>
          <p>Vendor Partner Portal</p>
        </div>

        <div className="vp-auth-card">
          <h2>Become a Vendor Partner</h2>
          <p className="sub">Fill in the details below to apply for a vendor account</p>

          {error && <div className="vp-alert vp-alert-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="vp-section-title" style={{ marginBottom: 12 }}>Basic Information</div>
            <div className="vp-form-grid" style={{ marginBottom: 20 }}>
              <Input label="Full Name" name="name" required />
              <Input label="Email Address" name="email" type="email" required />
              <Input label="Password" name="password" type="password" required />
              <Input label="Business Name" name="businessName" />
              <Input label="Contact Number" name="contactNumber" />
            </div>

            <div className="vp-section-title" style={{ marginBottom: 12 }}>Business Address</div>
            <div className="vp-form-grid" style={{ marginBottom: 20 }}>
              <Input label="Street" name="street" section="address" />
              <Input label="City" name="city" section="address" />
              <Input label="State" name="state" section="address" />
              <Input label="Pincode" name="pincode" section="address" />
            </div>

            <div className="vp-section-title" style={{ marginBottom: 12 }}>KYC Information</div>
            <div className="vp-form-grid" style={{ marginBottom: 20 }}>
              <Input label="GST Number" name="gstNo" />
              <Input label="PAN Number" name="panNo" />
              <Input label="Aadhaar Number" name="aadhaarNo" />
            </div>

            <div className="vp-section-title" style={{ marginBottom: 12 }}>Bank Details</div>
            <div className="vp-form-grid" style={{ marginBottom: 20 }}>
              <Input label="Account Holder Name" name="accountHolderName" section="bankDetails" />
              <Input label="Account Number" name="accountNumber" section="bankDetails" />
              <Input label="IFSC Code" name="ifscCode" section="bankDetails" />
              <Input label="Bank Name" name="bankName" section="bankDetails" />
            </div>

            <div className="vp-section-title" style={{ marginBottom: 12 }}>Upload Documents</div>
            <div className="vp-form-grid" style={{ marginBottom: 20 }}>
              <FileBox label="PAN Card" name="panCard" />
              <FileBox label="Aadhaar Card" name="aadhaarCard" />
              <FileBox label="Vendor Agreement" name="agreement" />
            </div>

            <div className="vp-checkbox-row" style={{ marginBottom: 20 }}>
              <input type="checkbox" checked={form.termsAccepted} onChange={e => setForm({ ...form, termsAccepted: e.target.checked })} />
              <span>I accept the <a href="#terms">Terms & Conditions</a> and <a href="#privacy">Privacy Policy</a> of V Angel Coin Pvt Ltd</span>
            </div>

            <button type="submit" className="vp-btn vp-btn-primary vp-btn-lg vp-btn-full" disabled={loading}>
              {loading ? "Submitting Application..." : "Register as Vendor"}
            </button>
          </form>

          <div className="vp-auth-footer" style={{ marginTop: 16 }}>
            Already have an account? <Link to="/vendor/login">Sign in here</Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorRegisterPage;
